import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ContentSet } from 'components/Shared/Scaffolding';
import Panel, { PanelTitle } from 'components/Shared/Panel';
import { SCAFFOLDING } from 'theme';
import { Icon, GLYPHS } from 'components/Shared/Icon';
import { routes } from 'modules/routes';

const propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

const StyledIcon = styled(Icon)`
    font-size: 1.5em;
    line-height: 1.7;
`;

const HelpPanel = ({ open, onClose }) => (
    <Panel open={open} onClose={onClose}>
        <ContentSet padding={SCAFFOLDING.GUTTER}>
            <PanelTitle>Help</PanelTitle>
            <h2>Introduction</h2>
            <p>
                Welcome to our Map Builder! With this tool you can create a Google Map that looks great and fits the
                style of your site with just a few clicks.
            </p>
            <h2>Creating a Map</h2>
            <p>
                There are 4 major sections of the map builder: style, size & location, markers (with popups), and
                advanced settings. Please refer to each panel for additional help with each section. Customize your map
                to your liking with the settings in the left panel and see a preview of your map on the right.
            </p>
            <h2>Saving</h2>
            <p>
                When you have the map the way you like it or would like to continue your work later, click the{' '}
                <StyledIcon glyph={GLYPHS.SAVE} /> Save panel in the toolbar to save your map to your account. All of
                your saved maps are accessible under{' '}
                <a href={routes.myMaps.path} rel="noopener noreferrer" target="_blank">
                    My Maps
                </a>{' '}
                if you would like to come back to it at any time.
            </p>
            <h2>View Code (Exporting)</h2>
            <p>
                Now that you are finished creating your perfect map, you need a way to get it onto your website. This is
                done by including the <code>iframe</code> tag on your site that embeds your map with all of the settings
                you have. See the <StyledIcon glyph={GLYPHS.CODE} /> View Code panel for more details.
            </p>
        </ContentSet>
    </Panel>
);

HelpPanel.propTypes = propTypes;

export default HelpPanel;
